import React, { type ReactElement } from 'react';
import { Box, Button, Icon } from '@saviynt/design-system';
import cx from 'classnames';

import { SodFooter } from '../../../../shared/components';
import { useTypedSelector } from '../../../../shared/hooks';

import './ViolationsTabFooter.css';

/**
 * ViolationsTabFooter
 */
function ViolationsTabFooter(): ReactElement {
  const {
    bulkaction: { isFooterVisible, bulkCount },
    sidepanel: { isSidePanelVisible },
  } = useTypedSelector((state) => state.aag.violationsTab);

  const sodFooterClasses = cx(
    'Sod-ViolationsTabFooter',
    isFooterVisible && 'Sod-ViolationsTabFooter--isFooterVisible',
    isSidePanelVisible && 'Sod-ViolationsTabFooter--isSidePanelVisible'
  );

  return (
    <SodFooter className={sodFooterClasses}>
      <div />
      <Box className='Sod-ViolationsTabFooter-wrapper'>
        <Button kind='outlined'>Clear Selection ({bulkCount})</Button>
        <Box className='Sod-ViolationsTabFooter-actionBtnWrapper'>
          <Button kind='outlined' leftIcon={<Icon kind='Report' />}>
            Generate Report ({bulkCount - Math.floor(bulkCount / 2)})
          </Button>
          <Button kind='outlined' leftIcon={<Icon kind='Consult' />}>
            Consult ({bulkCount - Math.floor(bulkCount / 3)})
          </Button>
          <Button kind='outlined' leftIcon={<Icon kind='SodMitigate' />}>
            Mitigate ({bulkCount - Math.floor(bulkCount / 4)})
          </Button>
        </Box>
      </Box>
    </SodFooter>
  );
}

export default ViolationsTabFooter;
